import { ExtraPage, ExtraPageResponse } from "burde";
import * as api from "util/api";

export const getStmExtraPages = async (
    culture: string,
    calendarSize: string,
    calendarType: string,
) => {
    try {
        const { success, data } = await api.json.get(`api/ui/GetExtraPages`, {
            culture,
            calendarSize,
            calendarType,
        });

        if (!success) {
            return;
        }

        return data as ExtraPageResponse;
    } catch (error) {
        return;
    }
};

export const getStmExtraPageById = async (
    culture: string,
    calendarSize: string,
    id: number,
) => {
    const { success, data } = await api.json.get(`api/ui/GetExtraPageById`, {
        id,
        culture,
        calendarSize,
    });

    if (!success) return;

    return data as ExtraPage;
};
